import React from 'react';
import styled from 'styled-components';

import Tooltip from 'antd/es/tooltip';

import { Text } from 'components/Text';
import Table from 'components/Table';

import {
  // formatDistanceToNow,
  formatDuration
} from 'helpers/date';

const ProcessAlerts = ({ isLoading, alerts }) => {
  return (
    <AlertsDataTable
      loading={isLoading}
      dataSource={alerts}
      rowKey="notification_id"
    >
      <Table.Column type="text" title="ID" dataIndex="notification_id" />
      <Table.Column type="text" title="Notification" dataIndex="title" render={(title, { content_msg }) => {
        return (
          <Tooltip placement="top" title={content_msg} trigger="hover">
            <Text>{title}</Text>
          </Tooltip>
        );
      }} />
      <Table.Column type="text" title="Employee ID" dataIndex="employee_id" />
      <Table.Column type="text" title="Tot Labor Expended" dataIndex="" render={(tot_labor_man_mins) => {
        if (typeof tot_labor_man_mins !== 'number') return '-';
        return formatDuration(tot_labor_man_mins * 60 * 1000, false);
      }} />
      <Table.Column type="text" title="Ack" dataIndex="is_acknowledged" render={(isAck) => {
        return isAck === 1 ? 'Yes' : 'No';
      }} />
      <Table.Column type="text" title="Ack By" dataIndex="acknowledged_by_name" />
      <Table.Column type="datetime" title="Ack At" dataIndex="acknowledge_date" />
      <Table.Column type="text" title="Read" dataIndex="is_read" render={(isRead) => {
        return isRead === 1 ? 'Yes' : 'No';
      }} />
      <Table.Column type="datetime" title="Created At" dataIndex="date_created" align="right" />
      <Table.Column type="datetime" title="Expires At" dataIndex="expires_on" align="right" />
      <Table.Column type="text" title="Comments" dataIndex="comments" align="center" />
    </AlertsDataTable>
  );
};

const AlertsDataTable = styled(Table)`
  & .ant-table {
    overflow: auto;
  }
`;

export default ProcessAlerts;
